import React from 'react'

import styled from '@emotion/styled'

import { Checkmark } from '@surglogs-app/icons'
import { FlexBox, TextBold, Icon } from '@surglogs-app/ui'

import { useTranslation } from '../services'

const StyledListItem = styled(TextBold)`
  display: flex;
  column-gap: ${({ theme }) => theme.ui.spacings.xs};
  background-color: ${({ theme }) => theme.ui.colors.background};
  border-radius: ${({ theme }) => theme.ui.spacings.sm};
  padding: ${({ theme }) => theme.ui.spacings.sm};
  white-space: nowrap;

  @media ${({ theme }) => theme.mq.md} {
    white-space: normal;
  }
`

interface PromoModalFeaturesGroupProps {
  featureName: string
}

export const PromoModalFeaturesGroup = ({
  featureName,
}: PromoModalFeaturesGroupProps) => {
  const { t } = useTranslation()
  const list: string[] = t(`features.${featureName}.list`, '', {
    returnObjects: true,
  })

  return (
    <FlexBox {...{ flex: 1, ai: 'center', wrap: 'wrap', gap: 'md' }}>
      {list.map((item, index) => (
        <StyledListItem key={index} {...{ size: 'xxs' }}>
          <Icon {...{ icon: Checkmark, variant: 'warning', size: 'md' }} />
          {item}
        </StyledListItem>
      ))}
    </FlexBox>
  )
}
